import { NgModule } from '@angular/core'
import { APP_BASE_HREF } from '@angular/common'
import { BootstrapModule } from '../../shared/browser/bootstrap.module'
import { RouterModule, Routes } from '@angular/router'
import { AppComponent } from '../../shared/browser/app.component'
import { ModelIdResolver } from 'framework/model-id-resolver/model-id.resolver'
import { EditionIdResolver } from 'framework/edition-id-resolver/edition-id.resolver'

const appBootstrapRoutes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import(
                '../../../modules/deals/configurator/resolvers/configuration-dealId/configuration-dealId-resolver.module'
            ).then(m => m.ConfigurationDealIdResolverModule),
        resolve: {
            modelId: ModelIdResolver,
            editionId: EditionIdResolver,
        },
    },
    {
        path: '**',
        redirectTo: '',
    },
]

@NgModule({
    imports: [BootstrapModule, RouterModule.forChild(appBootstrapRoutes)],
    bootstrap: [AppComponent],
    providers: [
        ModelIdResolver,
        EditionIdResolver,
        {
            provide: APP_BASE_HREF,
            useValue: window && window['mgBaseHref'] ? window['mgBaseHref'] : '/',
        },
    ],
})
export class AppModule {}
